import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fba6f33a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status-text" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { SecurityLevel } from './security-status.service'
import shieldDanger from './_images/shield-danger.png'
import shieldGood from './_images/shield-good.png'
import shieldExcellent from './_images/shield-excellent.png'
import Card from '@/views/dashboard/_components/card/card.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'overall-security-status',
  props: {
  level: {
    type: Number,
    default: SecurityLevel.DANGER
  },
  safeData: {
    type: Object,
    default: () =>({})
  },
},
  setup(__props) {

const { t, locale } = useI18n()

const props = __props

const currentConfig = computed(() => {
  void locale.value
  const byLevel = {
    [SecurityLevel.EXCELLENT]: { icon: shieldExcellent, text: t('overviewZone.levelExcellent'), class: 'status-excellent' },
    [SecurityLevel.GOOD]: { icon: shieldGood, text: t('overviewZone.levelGood'), class: 'status-good' },
    [SecurityLevel.DANGER]: { icon: shieldDanger, text: t('overviewZone.levelDanger'), class: 'status-danger' }
  }
  return byLevel[props.level] || byLevel[SecurityLevel.DANGER]
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('overviewZone.overallSecurityTitle'),
    class: _normalizeClass(["overall-security-status-wrap", currentConfig.value.class])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "shield-section",
        style: _normalizeStyle({ backgroundImage: `url(${currentConfig.value.icon})`})
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(currentConfig.value.text), 1)
      ], 4),
      _createVNode(_component_router_link, {
        to: "/dashboard/response-handle?isolation_status=1",
        class: "isolated-host"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('overviewZone.isolatedHosts')) + " ", 1),
          _createElementVNode("em", null, _toDisplayString(__props.safeData.isolation_count), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "class"]))
}
}

})